<template>
    <window-portal :open="dataProps.show">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center>
                <div>
                    <p style="font-size: 30px;">Vista previa de Reporte Cuentas Por Cobrar </p>
                </div>
            </center>
            <br />
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
            </center>
            <center>
                <div v-if="loading">
                    <p>Cargando...</p>
                </div>
            </center>

        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>

        <div class="book"
            style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
            <div style="display: flex; justify-content: space-around; ">
                <div ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
                    <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
                    <div v-for="(page, indexPage) in pages" :key="indexPage"
                        style="position: relative; height: 1000px; min-width: 1293px; background: white;">
                        <hr />
                        <div class="subpage" style="height: 1250px; padding-top: 20px; overflow: hidden;">
                            <div style="margin-left: 80px; margin-right: 50px;">
                                <div style=" font-size: 12px;">
                                    <!-- <hr />
                                    <hr /> -->
                                    <div>
                                        <span style="text-transform: uppercase; font-weight: 550; font-size: 14pt;">{{ dataProps.header.business.BusinessName }}</span>
                                        <br>
                                        <b>
                                            {{ dataProps.header.title }}
                                        </b>
                                        <!-- <p style="margin-top: 20px ;">Fecha de Emisión : {{ dataProps.header.cutDate }}
                                        </p> -->
                                    </div>
                                </div>

                                <!-- Heres is teh body -->
                                <div style="width: 100%;">
                                    <table style="width: 100% !important; font-size: 11px; border-collapse: collapse; ">
                                        <tr>
                                            <td colspan="14">

                                                <hr />

                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 2px;text-align: left;">NOMBRE CLIENTE</td>
                                            <td style="padding-left: 2px;text-align: left;">NÚMERO INTERNO</td>
                                            <td style="padding-left: 2px;text-align: left;">NÚMERO DE CONTROL</td>
                                            <td style="padding-left: 2px;text-align: left;">FECHA</td>
                                            <td style="padding-left: 2px;text-align: left;">VENCE</td>
                                            <td style="padding-left: 2px;text-align: end;">DÍAS</td>
                                            <td style="padding-left: 2px;text-align: center;">MONTO</td>
                                            <td style="padding-left: 2px;text-align: end;">ABONO</td>
                                            <td style="padding-left: 2px;text-align: end;">SALDO</td>
                                            <td style="padding-left: 2px;text-align: end;">0-30 días</td>
                                            <td style="padding-left: 2px;text-align: end;">31-60 días</td>
                                            <td style="padding-left: 2px;text-align: end;">61-90 días</td>
                                            <td style="padding-left: 2px;text-align: end;">91-120 días</td>
                                            <td style="padding-left: 2px;text-align: end;">120 -> días</td>
                                        </tr>
                                        <tr>
                                            <td colspan="14">


                                                <hr />
                                            </td>
                                        </tr>
                                        <!--tr v-for="(item, index) in dataProps.data.body" :key="index"-->
                                        <template v-for="(item, index) in valuesRows[indexPage]">
                                        <tr v-if="item.reportRowType" :key="`summary-${index}`" :style="totalRowStyle(item.reportRowType)">
                                            <td colspan="6" style="padding: 4px;text-align: left;">{{ item.LegalName }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.ChargesFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.PaymentsFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.BalanceFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.Balance_0_to_30_DaysFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.Balance_31_to_60_DaysFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.Balance_61_to_90_DaysFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.Balance_91_to_120_DaysFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.Over121Formatted }}</td>
                                        </tr>
                                        <tr v-else :key="`detail-${index}`">
                                            <!-- <td style="padding: 4px;text-align: center;" >{{ item.ID_Customer }}</td>  -->
                                            <td style="padding: 4px;text-align: left">{{ item.LegalName }}</td>
                                            <td style="padding: 4px;text-align: left;">{{ item.ID_Invoice }}</td>
                                            <td style="padding: 4px;text-align: left;">{{ item.NumeroControl }}</td>
                                            <td style="padding: 4px;text-align: left;">{{ item.InvoiceDateToShow }}</td>
                                            <td style="padding: 4px;text-align: left;">{{ item.ExpirationDateToShow }}
                                            </td>
                                            <td style="padding: 4px;text-align: end;">{{ item.Days }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.ChargesFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.PaymentsFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.BalanceFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{
                                                item.Balance_0_to_30_DaysFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{
                                                item.Balance_31_to_60_DaysFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{
                                                item.Balance_61_to_90_DaysFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{
                                                item.Balance_91_to_120_DaysFormatted }}</td>
                                            <td style="padding: 4px;text-align: end;">{{ item.Over121Formatted }}</td>
                                        </tr>
                                        </template>
                                    </table>
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
import 'jspdf-autotable'
//import QRCode from 'qrcode';
//import html2canvas from "html2canvas"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"

export default {
    name: "PrintResumeAccountsReceivableClient2",
    props: ['dataProps'],
    components: { WindowPortal },
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            //seal: "",
            //sealBranch: "",
            numPages: 0,
            Currency: JSON.parse(localStorage.getItem('branch')).Currency || '',
            //valuesRows: []
            mailLabel: null,
            valuesRows: [],
            urlQr: null,
            typePrint: 0,
            margins: {
                top: 40,
                bottom: 40,
                left: 40,
                right: 40
            },
            currentY: 40
        }
    },
    mounted() {
        this.calculatePagesOfDoc();
    },
    computed: {
        pages() {
            // Generar un arreglo con `numPages` elementos
            return Array.from({ length: this.numPages });
        },
    },
    watch: {
        'dataProps.show'() {
            if (this.dataProps.show) {
                setTimeout(async () => {
                    await this.calculatePagesOfDoc()
                }, 0);
            }
        },
        'dataProps'() {
            this.calculatePagesOfDoc()
        }
    },
    methods: {
        calculatePagesOfDoc() {
            try {
                this.typePrint = 0
                const reportRows = this.dataProps.data.body || [];
                this.valuesRows = [[]];
                reportRows.forEach((row, index) => {
                    let currentPage = this.valuesRows[this.valuesRows.length - 1];
                    const summaryFollows = Boolean(reportRows[index + 1]?.reportRowType);
                    if (currentPage.length >= 25 || (currentPage.length === 24 && summaryFollows)) {
                        currentPage = [];
                        this.valuesRows.push(currentPage);
                    }
                    currentPage.push(row);
                });
            }
            catch (err) {
                alert(err)
            }
            this.numPages = this.valuesRows.length;
        },

        configDoc() {
            const doc = new jsPDF('landscape', 'pt', 'letter');
            const headers = [[
                'NOMBRE CLIENTE',
                'NÚMERO INTERNO',
                'NÚMERO DE CONTROL',
                'FECHA',
                'VENCE',
                'DÍAS',
                'MONTO',
                'ABONO',
                'SALDO',
                '0 - 30 DÍAS',
                '31 - 60 DÍAS',
                '61 - 90 DÍAS',
                '91 - 120 DÍAS',
                'MAS DE 120 DÍAS',
            ]];
            const bodyRows = this.dataProps.data.body;
            const body = bodyRows.map(element => {
                if (element.reportRowType) return [
                    { content: element.LegalName, colSpan: 6 },
                    element.ChargesFormatted,
                    element.PaymentsFormatted,
                    element.BalanceFormatted,
                    element.Balance_0_to_30_DaysFormatted,
                    element.Balance_31_to_60_DaysFormatted,
                    element.Balance_61_to_90_DaysFormatted,
                    element.Balance_91_to_120_DaysFormatted,
                    element.Over121Formatted,
                ];
                return [
                    element.LegalName,
                    element.ID_Invoice,
                    element.NumeroControl,
                    element.InvoiceDateToShow,
                    element.ExpirationDateToShow,
                    element.Days,
                    element.ChargesFormatted,
                    element.PaymentsFormatted,
                    element.BalanceFormatted,
                    element.Balance_0_to_30_DaysFormatted,
                    element.Balance_31_to_60_DaysFormatted,
                    element.Balance_61_to_90_DaysFormatted,
                    element.Balance_91_to_120_DaysFormatted,
                    element.Over121Formatted,
                ]
            });

            doc.autoTable({
                startY: this.currentY,
                margin: { 
                    top: this.currentY,
                    left: 10, 
                    right: 10, 
                    bottom: 20 
                },
                willDrawPage: function (data) {
                    doc.setFontSize(10);
                    doc.setTextColor(40);
                    doc.setFont("helvetica", "bold");
                    const { business = "", } = JSON.parse(localStorage.getItem("user"));
                    doc.text(`${(business || '').toUpperCase()}`, data.settings.margin.left, 22).setFontSize(11);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(9);
                    doc.text(`Reporte de cuentas por cobrar `, data.settings.margin.left, 34);
                },
                head: headers,
                body: body,
                theme: 'plain',
                headStyles: {
                    textColor: 0,
                    halign: 'left',
                    valign: 'middle',
                    lineWidth: {
                        top: 0.5,    // Borde arriba
                        bottom: 0.5, // Borde abajo
                        left: 0,     // Sin borde lateral
                        right: 0
                    },
                    lineColor: [0, 0, 0]
                },
                styles: { 
                    cellPadding: 1.5, 
                    fontSize: 6,
                    halign: 'right',
                    // valign: 'start'
                },
                didParseCell: data => {
                    if (data.section !== 'body') return;
                    const rowType = bodyRows[data.row.index]?.reportRowType;
                    if (rowType) {
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.lineWidth = { top: 0.5 };
                    }
                },
                columnStyles: {
                    0: { cellWidth: 100, halign: 'left', },
                    1: { cellWidth: 70, fontSize: 5, halign: 'left',},
                    2: { cellWidth: 90, fontSize: 5, halign: 'left',},
                    3: { halign: 'left',},
                    4: { halign: 'left',},
                },
            })
            return doc;
        },

        totalRowStyle(rowType) {
            return rowType === 'grand-total'
                ? { fontWeight: 'bold', borderTop: '2px solid #000' }
                : { fontWeight: 'bold', borderTop: '1px solid #000' };
        },

        async Print() {
            this.loading = true
            const doc = this.configDoc();
            //doc.deletePage(2)

            doc.autoPrint({ variant: 'non-conform' });
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download() {
            this.loading = true
            const doc = this.configDoc();
            doc.save("Resumen Cuentas Por Cobrar.pdf")
            this.loading = false
        },
    }
}
</script>

<style scoped>
.u-row .u-col-100 {
    width: 100% !important;
}

.btnclean {
    border-radius: 15px;
    border: 1px solid white;
    background-color: #F29D35 !important;
    color: white !important;
}

.btnclose {
    border-radius: 15px;
    border: 1px solid white;
    background-color: rgb(255, 38, 38) !important;
    color: white !important;

}

* {
    font-family: Arial, Helvetica, sans-serif !important;
}
</style>
